














































































































































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

import { bus } from '../main'

import HeaderLogo from '@/components/HeaderLogo.vue'
import AdminDrawer from '@/components/admin/AdminDrawer.vue'
import SearchBar from '@/components/SearchBar.vue'
import Cart from '@/components/Cart.vue'
import EditVehicleSelection from '@/components/EditVehicleSelection.vue'
import ModelsList from '@/components/ModelsList.vue'
import YearModelSelector from './YearModelSelector.vue'

export default Vue.extend({
  data: () => ({
    adminDrawer: false,
    cartDrawer: false,
    modelSelectorDialog: false,
    timeout: 5000,
    noVehicleSelectionList: ['Home', 'Admin', 'Dealer Products', 'Manufacturer Products', 'Orders', 'Behaviour', 'Audience', 'Users', 'Customers', 'Sales', 'Advisors', 'CustomerAccounts', 'Login'] as string[],
    signOutSnackbar: false as boolean,
    logoutDialog: false as boolean,
    loading: false as boolean
  }),
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      isAdmin: 'auth/isDealerAdmin',
      currentDealer: 'dealers/currentDealer',
      currentDealerId: 'dealers/currentDealerId',
      currentTrim: 'trims/currentTrim',
      numProducts: 'cart/numProducts',
      years: 'years/yearsForMake',
      selectedModelId: 'models/currentModelId'
    }),
    extended() : boolean {
      const { xs, sm } = this.$vuetify.breakpoint
      return xs || sm
    }
  },
  methods: {
    ...mapActions({
      signOutAction: 'auth/signOut',
    }),
    account() : void {
      if (this.authenticated) {
        this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/account')
      } else {
        this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/login')
      }
    },
    checkout() : void {
      if (this.authenticated) {
        this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/checkout')
      } else {
        this.$router.push({ path: '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/login', query: { redirect: '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/checkout' } })
      }
      this.cartDrawer = false
    },
    home(): void {
      const path = '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode
      this.$store.commit('models/clearCurrentModel')
      this.$store.commit('trims/clearCurrentTrim')
      if (this.$route.path !== path) {
        this.$router.push({ path: '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode })
      }
    },
    closeModelDialog() : void {
      this.modelSelectorDialog = false
    },
    async signOut () {
      this.loading = true
      const response = await this.signOutAction()
      if (response === 200) {
        this.signOutSnackbar = true
        this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/login')
      }
      this.loading = false
      this.logoutDialog = false
    },
    removeSnackbar() : void {
      this.$store.commit('cart/removeSnackbar')
    },
    openCartDrawer() : void {
      this.cartDrawer = true
    }
  },
  mounted() {
    bus.$on('openCartDrawer', this.openCartDrawer)
  },
  components: {
    HeaderLogo,
    SearchBar,
    Cart,
    EditVehicleSelection,
    ModelsList,
    YearModelSelector,
    AdminDrawer
  }
})
